import { render, staticRenderFns } from "./CrmLeadReminderPopupWrappable.vue?vue&type=template&id=11858dd1&lang=pug&"
import script from "./CrmLeadReminderPopupWrappable.vue?vue&type=script&lang=js&"
export * from "./CrmLeadReminderPopupWrappable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports